import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Encounter } from '@mona/models';
import { ChangeLogService } from '@mona/pdms/data-access-changelog';
import * as AuditLogActions from '../state/actions/audit.log.actions';
import { AuditLogState } from '../state/reducers/audit-log.reducer';

/**
 * Audit log service
 */
@Injectable({ providedIn: 'root' })
export class AuditLogService {
    /**
     * Constructor
     *
     * @param store Store
     * @param changeLogService ChangeLogService
     */
    constructor(private store: Store<AuditLogState>, private changeLogService: ChangeLogService) {}

    /** Clear audit log */
    clearAuditLog(): void {
        this.store.dispatch(AuditLogActions.clearAuditLog());
    }

    /**
     * Load audit log
     * @param encounter
     */
    loadAuditLog(encounter: Encounter): void {
        this.store.dispatch(AuditLogActions.loadAuditLogs({ encounter }));
    }
}
